export class UserAudioRecordingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAudioRecording() {
    return this.#http.get('/AudioRecording');
  }

  async getAudioRecordingUrl({ audioRecordingId }) {
    return this.#http.get(`/AudioRecording/${audioRecordingId}/url`);
  }

  async createAudioRecording({ signal, ...body }) {
    return this.#http.post('/AudioRecording', body, { signal });
  }

  async editAudioRecording({ audioRecordingId, signal, ...body }) {
    return this.#http.put(`/AudioRecording/${audioRecordingId}`, body, { signal });
  }

  async editAudioRecordingContent({ audioRecordingId, formData }) {
    return this.#http.put(`/AudioRecording/${audioRecordingId}/content`, formData, {
      'Content-Type': 'multipart/form-data',
    });
  }

  async deleteAudioRecording({ audioRecordingId }) {
    return this.#http.delete(`/AudioRecording/${audioRecordingId}`);
  }

  // Voicemail greeting (DEV-1575)
  async getActiveGreeting() {
    return this.#http.get('/AudioRecording/greeting');
  }

  async setActiveGreeting({ audioRecordingId }) {
    return this.#http.put('/AudioRecording/greeting', { audioRecordingId });
  }

  async removeActiveGreeting() {
    return this.#http.delete('/AudioRecording/greeting');
  }
}
